import React, { Component } from "react";
import { connect } from "react-redux";
import DBManager from "../../services/db-manager";
import constants from "../../globalization";
import { getPopupConfig } from "../../components/Popup";
import { LogLevelEnum } from "../../enums";
import View from "./views";
import MenuUtils from './common';
import MUTIL from 'mroads-js-utils';
import withSocketContext from '../../context-api/SocketContext/withSocketContext';
import FireboardUtils from "../../util/fireboard-util";
import EventEmitter from '../../util/event-emitter';

class KitchenApp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      popup: undefined,
      selectedKitchenType: 0,
      orders: [],
      ordersToBeShown: [],
      completedOrders: [],
      currentPage: 1,
      isComplete: false,
      numberOfTiles: 6,
      isDevEnvironment: false,
    };
    this.orders = new Map();
    this.checks = new Map();
    this.checkSubscriber = null;
    this.items = [];
    this.checksRetrieved = false;
  }

  async componentDidMount() {
    const {
      history,
      reduxProps: { storeInfo, deviceInfo },
    } = this.props;

    if (!storeInfo.data || !deviceInfo.deviceExternalId) {
      history.push({
        pathname: '/',
        state: { deviceTypeId: 14 }
      });
      return;
    }

    if (window.ReactNativeWebView) {
      EventEmitter.addLogs(
        'appLogs',
        LogLevelEnum.INFO,
        `Mounting KDS component with storeId ${storeInfo?.data?.id} and deviceExternalId ${deviceInfo?.deviceExternalId}`
      );
    }

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      this.state.isDevEnvironment = true;
    }

    // this.connectToRedis();
    // sampleJson.forEach(check => {
    //   this.populateOrders(check);
    // });

    const { context } = this.props;
    this.setChecks(context?.checks);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props?.context !== nextProps?.context) {
      const { checks, deletedChecks, updatedChecks } = nextProps.context;
      if (this.props?.context.checks !== checks && !this.checksRetrieved) {
        this.setChecks(checks);
        this.checksRetrieved = true;
      }
      if ((deletedChecks && deletedChecks.length > 0) || (updatedChecks && updatedChecks.size > 0)) {
        this.setUpdatedChecks(deletedChecks, updatedChecks);
      }
    }
  }

  setChecks = (checks) => {
    if (checks) {
      const allChecks = Array.from(checks.values());
      allChecks && allChecks.forEach(check => {
        this.checks.set(check.id, check);
        this.populateOrders(check);
      });
      this.setOrders();
    }
  }

  setUpdatedChecks = (deletedChecks, updatedChecks) => {
    if (deletedChecks && deletedChecks.length > 0) {
      deletedChecks.forEach(checkId => {
        this.checks.delete(checkId);
      });
    }
    if (updatedChecks) {
      const { context } = this.props;
      const { resetUpdatedChecks } = context;
      const allUpdatedChecks = Array.from(updatedChecks.values());
      allUpdatedChecks && allUpdatedChecks.forEach(eachCheck => {
        this.checks.set(eachCheck.checkHeaderId, eachCheck);
        this.populateOrders(eachCheck);
      });
      resetUpdatedChecks(updatedChecks);
    }
    this.setOrders();
  };

  getOrderTypeName = (id) => {
    const { reduxProps } = this.props;
    const { storeInfo } = reduxProps;
    const orderTypeDetails = storeInfo.data.orderTypes.find(
      (each) => each.id === id
    );
    if (orderTypeDetails) {
      return orderTypeDetails.name;
    }
    return "";
  };

  // populateOrders = (check) => {
  //   const { currentPage, numberOfTiles } = this.state;
  //   const checkOrderItems = check?.orders[0]?.items;
  //   const orderItems = checkOrderItems.map(i => {
  //     const orderJson = JSON.parse(i.orderJson);
  //     const modifierJson = JSON.parse(orderJson.modifierJson);
  //     return {
  //       ...orderJson,
  //       ...modifierJson,
  //       ...i,
  //       modifiers: orderJson.modifiers,
  //     };
  //   });

  //   const orders = orderItems && orderItems.reduce((order, eachItem) => {
  //     order[eachItem.guid] = [...order[eachItem.guid] || [], eachItem];
  //     return order;
  //   }, {});

  //   for (var order in orders) {
  //     this.orders.set(order, this.populateData(orders[order], check));
  //   }

  //   this.items = MenuUtils.getItems(this.orders);
  //   const ordersMapValues = [...this.orders.values()];
  //   const pending = ordersMapValues.filter(order => order.orderStatus === 0);
  //   this.setState({ orders: pending, ordersToBeShown: [...pending].slice((currentPage - 1) * numberOfTiles, currentPage * numberOfTiles) });
  // }

  populateOrders = (check) => {
    const kitchenItems = check?.items || [];
    this.orders.set(check.id, this.populateData(kitchenItems, check));

    // const kitchenOrders = check?.orders || [];
    // kitchenOrders && kitchenOrders.forEach(order => {
    //   const checkOrderItems = order.items;
    //   const orderItems = checkOrderItems.map(i => {
    //     const orderJson = JSON.parse(i.orderJson);
    //     const modifierJson = JSON.parse(orderJson.modifierJson);
    //     return {
    //       ...orderJson,
    //       ...modifierJson,
    //       ...i,
    //       modifiers: orderJson.modifiers,
    //     };
    //   });
    //   this.orders.set(order.id, this.populateData(orderItems, check));
    // });
  };

  setOrders = () => {
    const { currentPage, numberOfTiles } = this.state;
    this.items = MenuUtils.getItems(this.orders);
    const ordersMapValues = [...this.orders.values()];
    const pending = ordersMapValues.filter(order => order.orderStatus === 0);
    this.setState({ orders: pending, ordersToBeShown: [...pending].slice((currentPage - 1) * numberOfTiles, currentPage * numberOfTiles) });
  };

  populateData = (items, check) => {
    const orderId = check.orderTypeId;
    return {
      stationId: check.stationId,
      stationName: check.stationName,
      checkNumber: check.checkNumber || '- -',
      orderDate: check.orders[0].orderDate,
      orderType: this.getOrderTypeName(orderId),
      serverName: `${check.employeeFirstName || '-'} ${check.employeeLastName || '-'}`,
      items: items,
      id: check.id,
      uniqueId: MUTIL.generateUniqueId(),
      orderStatus: 0,
    }
  }

  deleteOrders = (check) => {
    const checkItems = check?.orders[0]?.items;
    checkItems.forEach(item => {
      if (this.orders.get(item.guid))
        this.orders.delete(item.guid);
    });
  }

  getPopup = (type, heading, message, callback) => {
    const popup =
      type === "spinner"
        ? getPopupConfig("spinner")
        : getPopupConfig("error", () => {
          callback && callback();
          this.setState({ popup: undefined });
        });
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    this.setState({ popup });
  };

  closePopup = (event, callback = () => { }) => {
    this.setState(
      { popup: undefined },
      () => !!callback && callback()
    );
  };

  onKitchenTypeSelect = (kitchenType) => {
    const { selectedKitchenType } = this.state;
    if (selectedKitchenType === kitchenType.id) return;

    switch (kitchenType.id) {
      case 0:
        this.state.selectedKitchenType = kitchenType.id;
        this.setExpoOrders();
        break;
      default:
        this.state.selectedKitchenType = kitchenType.id;
        this.setSectionItems();
        break;
    }
  };

  setExpoOrders = () => {
    let { orders, numberOfTiles } = this.state;
    numberOfTiles = 6;
    const ordersMapValues = [...this.orders.values()];
    orders = ordersMapValues.filter(order => order.orderStatus === 0);
    this.setState({
      orders,
      ordersToBeShown: [...orders].slice(0, numberOfTiles),
      currentPage: 1,
      numberOfTiles,
    });
  }

  setSectionItems = () => {
    let { orders, numberOfTiles, isComplete, selectedKitchenType } = this.state;
    numberOfTiles = 5;
    orders = this.items.filter(it => it.kitchenTypeId === selectedKitchenType && it.completed === isComplete);
    this.setState({
      orders,
      ordersToBeShown: [...orders].slice(0, numberOfTiles),
      currentPage: 1,
      numberOfTiles,
    });
  };

  handleActions = type => {
    switch (type) {
      case 'completed': {
        const { completedOrders, currentPage, isComplete, orders, numberOfTiles, selectedKitchenType } = this.state;
        if (selectedKitchenType === 0) {
          const arrayToBrShown = isComplete ? orders : completedOrders;
          const content = [...arrayToBrShown].slice((currentPage - 1) * numberOfTiles, currentPage * numberOfTiles);
          this.setState({ ordersToBeShown: content, currentPage: 1, isComplete: !isComplete });
        } else {
          this.state.isComplete = !isComplete;
          this.setSectionItems();
        }
        break;
      }
      case 'allDay':
        break;
      case 'config':
        break;
      default:
        break;
    }
  };

  onPaginateLeft = () => {
    const { currentPage, orders, numberOfTiles } = this.state;
    if (currentPage === 1) return;

    const temp = currentPage - 1;
    const content = [...orders].slice((temp - 1) * numberOfTiles, temp * numberOfTiles);
    this.setState({ currentPage: temp, ordersToBeShown: content });
  }

  onPaginateRight = () => {
    const { orders, currentPage, numberOfTiles } = this.state;
    const totalPages = Math.ceil(orders.length / numberOfTiles);
    if (currentPage === totalPages) return;

    const temp = currentPage + 1;
    const content = [...orders].slice(currentPage * numberOfTiles, (currentPage + 1) * numberOfTiles);
    this.setState({ currentPage: temp, ordersToBeShown: content });
  }

  onOrderClick = orderUniqueId => {
    const { orders, currentPage, completedOrders, isComplete, numberOfTiles } = this.state;
    const index = orders.findIndex(item => item.uniqueId === orderUniqueId);
    const completedIndex = completedOrders.findIndex(c => c.uniqueId === orderUniqueId);

    if (completedIndex === -1) {
      completedOrders.push(orders[index]);
      orders.splice(index, 1);
    } else {
      orders.push(completedOrders[completedIndex]);
      completedOrders.splice(completedIndex, 1);
    }
    const arrayToBrShown = isComplete ? completedOrders : orders;

    const content = [...arrayToBrShown].slice((currentPage - 1) * numberOfTiles, currentPage * numberOfTiles);
    this.setState({ ordersToBeShown: content, completedOrders });
  }

  onItemClick = item => {
    let newItems = this.items.length && this.items.map(it => {
      return {
        ...it,
        completed: item.id === it.id ? !it.completed : it.completed,
      }
    });
    this.items = newItems;
    this.setSectionItems();
  };

  onClickMenuOption = type => {
    switch (type) {
      case 'settings':
        break;
      case 'diagnostics':
        const { history } = this.props;
        history && history.push({
          pathname: '/diagnostics',
          state: {
            themeColor: '#000000',
          },
        });
        break;
      case 'about':
        this.setState({ popup: { type: 'about' } });
        break;
      case 'networkLogs':
        this.setState({ popup: { type: 'networkLogs' } });
        break;
      default:
        console.warn('case not handled!!!');
        break;
    }
  };

  reSync = () => {
    const callback = () => {
      this.getPopup('spinner', constants.sync, null);
      this.unsubscribeRethinkListeners();
      this.onIntialize = DBManager.addListener('initialize', this.reSync);
      this.checks = new Map();
      const successCallback = () => {
        this.setState({ popup: undefined });
      };
      EventEmitter.addLogs(
        'syncLogs',
        LogLevelEnum.INFO,
        "Syncing with your POS"
      );
      this.getDataFromRedis(successCallback);
    };
    callback();
  };

  getDataFromRedis = (callback) => {
    this.getAllChecks(callback);
  };

  getAllChecks = (callback) => {
    const {
      reduxProps: { storeInfo },
    } = this.props;
    const { id: storeId } = storeInfo?.data;
    DBManager.getStoreChecks(storeId, (error, response) => {
      if (error) {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.ERROR,
          "Get store checks errored out"
        );
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        this.getPopup("error", null, errorMsg);
      } else {
        EventEmitter.addLogs(
          'syncLogs',
          LogLevelEnum.INFO,
          "Response from Get store checks"
        );
        this.setChecks(response);
        callback && callback();
      }
    });
  };

  unsubscribeRethinkListeners = () => {
    this.onIntialize && this.onIntialize();
  };

  get viewProps() {
    const {
      popup,
      selectedKitchenType,
      orders,
      completedOrders,
      currrentPage,
      ordersToBeShown,
      isComplete,
      isDevEnvironment,
    } = this.state || {};
    const { reduxProps } = this.props;
    const { fbNetworkLogs, currencyInfo, storeInfo, deviceApi, deviceApiData } = reduxProps || {};
    const { deviceName } = deviceApi?.data || deviceApiData || {};
    const { networkLogs } = fbNetworkLogs || {};
    const { rnDevEnv, iso2 } = currencyInfo || {};
    const infoMetaData = {
      storeName: storeInfo?.data?.name,
      isDevEnvironment,
      supportNumber: FireboardUtils.formattedPhoneNumber(storeInfo?.data?.supportPhoneNumber, iso2),
      rnDevEnv,
      baseUrl: window.location.origin || '',
    };
    return {
      popup,
      closePopup: this.closePopup,
      selectedKitchenType,
      onKitchenTypeSelect: this.onKitchenTypeSelect,
      handleActions: this.handleActions,
      orders,
      completedOrders,
      currrentPage,
      ordersToBeShown,
      onPaginateLeft: this.onPaginateLeft,
      onPaginateRight: this.onPaginateRight,
      onOrderClick: this.onOrderClick,
      isComplete,
      onItemClick: this.onItemClick,
      infoMetaData,
      networkLogs,
      onClickMenuOption: this.onClickMenuOption,
      reSync: this.reSync,
      deviceName,
    };
  }

  render() {
    const viewProps = this.viewProps;
    return <View {...viewProps} />;
  }
}

const mapStateToProps = (reduxProps) => ({
  reduxProps,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withSocketContext(KitchenApp));
